import { Plug } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/shared/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

const PLANNED: Array<{ category: string; apps: string[] }> = [
  { category: 'Email', apps: ['Outlook', 'Gmail'] },
  { category: 'Calendar', apps: ['Microsoft 365', 'Google Workspace'] },
  { category: 'Accounting', apps: ['Xero', 'QuickBooks', 'FreeAgent'] },
  { category: 'Storage', apps: ['Box', 'Dropbox', 'OneDrive'] },
  { category: 'Comms', apps: ['Slack', 'Microsoft Teams'] },
  { category: 'Meetings', apps: ['Zoom', 'Google Meet'] },
  { category: 'eFiling', apps: ['CE-File (HMCTS)', 'PCOL'] },
  { category: 'Compliance', apps: ['SmartSearch (KYC)'] },
];

export default function IntegrationsPage() {
  const navigate = useNavigate();

  return (
    <div>
      {/* One component, two routes — /admin/integrations and /barrister/settings/apps — so the
          way back depends on who is looking. History knows; a fixed destination would not. */}
      <PageHeader
        title="App Integrations"
        subtitle="Connect the platform to the tools your chambers already uses"
        onBack={() => navigate(-1)}
      />

      <Card className="mb-6">
        <CardContent className="px-6 py-12 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 text-brand-600 dark:text-brand-400">
            <Plug className="h-6 w-6" weight="bold" />
          </div>
          <div className="text-lg font-semibold text-foreground">App integrations coming soon</div>
          <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-muted-foreground">
            We're building first-party connectors instead of listing third-party apps that don't
            actually work. The categories below are on the roadmap. Email, calendar and CSV
            export-style integrations land first.
          </p>
        </CardContent>
      </Card>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {PLANNED.map((cat) => (
          <Card key={cat.category}>
            <CardContent className="p-5">
              <div className="mb-2 text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">
                {cat.category}
              </div>
              <ul className="space-y-1 text-sm text-foreground">
                {cat.apps.map((a) => (
                  <li key={a}>{a}</li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
